import React from "react";
import styled from "@emotion/styled";
import { GatsbyImage } from "gatsby-plugin-image";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Mousewheel, Pagination } from "swiper";
import "swiper/css/bundle";

SwiperCore.use([Mousewheel, Pagination]);

const WrapperSlide = styled.div`
  display: flex;
  align-items: center;
  padding: 2em 0em;
  @media (max-width: 591px) {
    padding: 1em 0em;
  }
`;

const SwiperContent = styled(Swiper)`
  .swiper-slide {
    margin-bottom: 1em;
    margin-top: 1em;
  }
  .swiper-pagination {
    display: "block";
    bottom: -0.2em;
    text-align: left;
  }
  .swiper-pagination-bullet-active {
    background-color: #fbb400;
  }
`;

const SlideImage = (props) => {
  const { imageObject } = props;
  const slides = imageObject.edges.map(({ node }) => (
    <GatsbyImage
      loading="lazy"
      style={{ border: "1px solid rgba(64,87,109,.07)", borderRadius: 5 }}
      image={node.childImageSharp.gatsbyImageData}
      alt={node.base}
    />
  ));

  return (
    <>
      <SwiperContent
        direction={"horizontal"}
        spaceBetween={20}
        slidesPerView={1.5}
        pagination={{ clickable: true }}
        mousewheel={true}
      >
        {slides.length > 0 &&
          slides.map((slideContent, index) => (
            <SwiperSlide key={index}>{slideContent}</SwiperSlide>
          ))}
      </SwiperContent>
    </>
  );
};

const ThirdComponent = ({ imageObject }) => {
  return (
    <WrapperSlide>
      <SlideImage imageObject={imageObject} />
    </WrapperSlide>
  );
};

export default ThirdComponent;
